import Repository from '@/libs/axios'

const profileResource = '/admin/staff/upload-profile-picture'

export default {
  updateprofileImage(file) {
    const formData = new FormData()
    formData.append('profile_picture', file)
    return Repository.post(`${profileResource}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
}
